((BackInStock, $) => {
  'use strict';

  const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  let $open;
  let $email;
  let $submit;
  let $messages;
  let $success;
  let $error;

  const cacheDom = () => {
    $open = $('.js-bis-open');
    $email = $('.js-bis-email');
    $submit = $('.js-bis-submit');
    $messages = $('.js-bis-messages');
    $success = $messages.find('.js-bis-success');
    $error = $messages.find('.js-bis-error');
  };

  const setupForm = (variantId, productId) => {
    $submit.attr('data-variant-id', variantId)
      .attr('data-product-id', productId);
  };

  const validate = (inputEmail) => {
    if (emailRegexp.test(inputEmail)) {
      return inputEmail;
    }

    return false;
  };

  const bindUIActions = () => {
    $open.on('click', function buttonClick(event) {
      event.preventDefault();

      const $this = $(this);
      const variantId = $this.data('variant-id');
      const productId = $this.data('product-id');

      setupForm(variantId, productId);
      $email.show();
      $submit.show();
      $success.hide();
      $error.hide();
    });

    $submit.on('click', function submit() {
      event.preventDefault();

      const $this = $(this);
      const variantId = $this.data('variant-id');
      const productId = $this.data('product-id');
      const email = validate($email.val());

      let success = false;

      if (email && variantId && productId) {
        window.BIS.create(email, variantId, productId).then((response) => {
          if (response.status === 'OK') {
            success = true;
            $submit.hide();
            $email.hide();
            $error.hide()
            $success.show();
          } else {
            success = false;
            $error.show();
          }
        });
        return success;
      }

      $error.show();
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  BackInStock.init = init;
})(window.BackInStock = window.BackInStock || {}, jQuery);
